<template>
    <div class="my_goods_record">
        <ul class="status_list">
            <li v-for="(item,i) in statusList" :key="i" :class="{'active': item.status == status}"
                @click="changeStatus(item.status)">{{ item.name }}</li>
        </ul>
        <div class="record_goods_list">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <order-scroll :url="url" :params="params" ref="record">
                    <template slot-scope="scope">
                        <div v-for="(item,i) in scope.data" :key="i">
                            <order-box :info="item"
                            :index="i" :otype="params.otype" @finishFunc="finishFunc"/>
                        </div>
                    </template>
                </order-scroll>
            </van-pull-refresh>
        </div>
    </div>
</template>

<script>
    import orderbox from './order/OrderBox'
    export default {
        data() {
            return {
                statusList: [{
                        status: 0,
                        name: '全部'
                    },
                    {
                        status: 3,
                        name: '待付款'
                    },
                    {
                        status: 1,
                        name: '待发货'
                    },
                    {
                        status: 2,
                        name: '交易完成'
                    },
                ],
                isLoading: false,
                url: 'order/order-list',
                params: {
                    otype: 1, //1购买 2出售
                },
            }
        },
        components: {
            OrderBox: orderbox
        },
        computed: {
            status() {
                return this.$route.params.status
            }
        },
        created() {},
        mounted() {},
        methods: {
            finishFunc(i) {
                this.$refs.record.data[i].status = 4
            },
            changeStatus(status) {
                if (status == this.status) return
                this.$router.replace({
                    name: 'user.buy',
                    params: {
                        status
                    }
                })
                this.$refs.record.refresh()
            },
            onRefresh() {
                setTimeout(() => {
                    this.isLoading = false;
                    this.$refs.record.refresh()
                }, 1000);
            }
        },
        watch: {
            status: {
                immediate: true,
                handler(s) {
                    if (s == 1) {
                        this.params = {
                            otype: 1,
                            status: 0
                        }
                    } else if (s == 2) {
                        this.params = {
                            otype: 1,
                            status: 1
                        }
                    } else if (s == 3) {
                        this.params = {
                            otype: 1,
                            status: 2
                        }
                    } else if (s == 0) {
                        this.params = {
                            otype: 1
                        }
                    }
                }
            }
        },

    }
</script>

<style lang="less" scoped>
    .status_list {
        position: fixed;
        width: 100%;
        max-width: 525px;
        top: 5rem;
        left: 50%;
        transform: translateX(-50%);
        background-color: var(--innerbgc);
        height: 4rem;
        padding: 0 2rem;
        display: flex;
        align-items: center;
        z-index: 10;

        li {
            font-size: 1.6rem;
            color: #000;
            margin-right: 3rem;
            cursor: pointer;

            &.active {
                font-weight: 700;
                color: var(--theme);
            }
        }
    }

    .record_goods_list {
        padding-top: 6rem;
    }
</style>